export default "__VITE_ASSET__da05d63b__"